var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 80,
    viewBox: "0 0 89 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5508 40.0317H8.85003C4.46524 40.0317 0.877686 36.4441 0.877686 32.0593V8.14227C0.877686 3.75748 4.46524 0.169922 8.85003 0.169922H32.7671C37.1519 0.169922 40.7394 3.75748 40.7394 8.14227V32.0593C40.7394 32.1775 40.7368 32.295 40.7317 32.4119V40.0314C40.7317 53.3973 36.2994 67.3316 26.6964 76.9345C23.9274 79.7035 19.438 79.7035 16.6691 76.9345C13.9001 74.1655 13.9001 69.6761 16.6691 66.9072C23.0108 60.5655 26.5508 50.5828 26.5508 40.0317ZM74.3849 40.0317H56.6841C52.2993 40.0317 48.7118 36.4441 48.7118 32.0593V8.14227C48.7118 3.75748 52.2993 0.169922 56.6841 0.169922H80.6011C84.9859 0.169922 88.5735 3.75748 88.5735 8.14227V32.0593C88.5735 32.1775 88.5709 32.2951 88.5657 32.4121V40.0314C88.5657 53.3973 84.1334 67.3315 74.5305 76.9345C71.7615 79.7035 67.2721 79.7035 64.5031 76.9345C61.7342 74.1655 61.7342 69.6761 64.5031 66.9072C70.8448 60.5655 74.3849 50.5828 74.3849 40.0317Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote2);
export default __webpack_public_path__ + "static/media/quote2.c9cbad53fc5903d2f101918af919cee7.svg";
export { ForwardRef as ReactComponent };